//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Location = createAsyncThunk(
  "Location",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingLocation(""));
      const response = await UsePortalApi(
        `Patient/Location`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response, "response");
        dispatch(gettingLocationSuccess(response[0].entry));
      } else {
        dispatch(gettingLocationFailed(response?.errorMessage));
      }
    } catch (error) {
      dispatch(gettingLocationFailed(error));
    }
  }
);
const LocationSlice = createSlice({
    name: "Location",
    initialState: {
      LocationData: null,
      isLocation: false,
      errorLocation: false,
    },
    reducers: {
      gettingLocation: (state, action) => {
        state.LocationData = null;
        state.isLocation = true;
        state.errorLocation = false;
      },
      gettingLocationSuccess: (state, action) => {
        state.LocationData = action.payload;
        state.isLocation = false;
        state.errorLocation = false;
      },
      gettingLocationFailed: (state, action) => {
        state.LocationData = null;
        state.isLocation = false;
        state.errorLocation = true;
      },
      gettingLocationClear: (state, action) => {
        state.LocationData = null;
        state.isLocation = false;
        state.errorLocation = false;
      },
    },
});
export const {
  gettingLocation,
  gettingLocationSuccess,
  gettingLocationFailed,
  gettingLocationClear,
} = LocationSlice.actions;
export default LocationSlice.reducer;
